import { render, staticRenderFns } from "./Prodes2013.vue?vue&type=template&id=e584628a&lang=pug"
import script from "./Prodes2013.vue?vue&type=script&lang=js"
export * from "./Prodes2013.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports